<template>

    <div class="row">
        <div class="main-content col-12 col-md-7 col-lg-5 mx-auto">
            <div class="account-box">
                <router-link to="/" class="logo">
                    <img :src="baseInfo.LogoPicPath" :title="baseInfo.ShopName" :alt="baseInfo.ShopName" />
                </router-link>
                 
                <div class="account-box-title">تغییر رمز عبور</div>
                <div class="account-box-content">
                    <ul style="color:red;font-size:12px;text-align:center;list-style-type:circle;margin-top:10px;">
                        <li v-for="error in errors.all()">{{ error }}</li>
                    </ul>
                    <form @submit.prevent="validateForm" class="form-account">
                        <div class="form-account-title">رمز عبور جدید</div>
                        <div class="form-account-row">
                            <label class="input-label">
                                <i class="now-ui-icons ui-1_lock-circle-open"></i>
                            </label>
                            <input class="input-field" type="password" v-model="user.Password" v-validate="{required: true , min : 4 , max: 12}" ref="password" data-vv-as="رمز عبور"
                                   placeholder="رمز عبور جدید خود را وارد نمایید">
                        </div>
                        <div class="form-account-title">تکرار رمز عبور جدید</div>
                        <div class="form-account-row">
                            <label class="input-label">
                                <i class="now-ui-icons ui-1_lock-circle-open"></i>
                            </label>
                            <input class="input-field" type="password" v-model="user.RePassword" v-validate="{required: true,confirmed: 'password' , min : 4 , max: 12}" data-vv-as="تکرار رمز عبور"
                                   placeholder="رمز عبور جدید خود را مجددا وارد نمایید">
                        </div>
                        <div class="form-account-row form-account-submit">
                            <div class="parent-btn">
                                <button class="dk-btn dk-btn-info">
                                    تغییر رمز عبور
                                    <i class="now-ui-icons arrows-1_refresh-69"></i>
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import { httpPromise } from "../../../module/httpUtility";
    export default {
        data() {
            return {
                user: { ConfirmationCodeHashId : ''  }
            }
        } , 
        computed: {
            confirmationCodeHashId: function () {
                return this.$store.getters.readConfirm.confirmationCodeHashId;
            }, 
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },
        methods: {
            validateForm() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        this.user.ConfirmationCodeHashId = this.confirmationCodeHashId;
                        httpPromise(this, '/v1/Identity/ForgetPassword/SetNewPassword', 'post', JSON.stringify(this.user),
                            response => {
                                toastr.remove();
                                localStorage.setItem('accessToken', response.data.Value.Token);
                                this.$store.commit('setUserFullName', response.data.Value.UserFullName);
                                this.$emit('redirectToComplete', '');
                            },
                            response => {
                                toastr.error(response.data.Message);
                            });
                    }
                });
            },
        },
        beforeMount: function () {
            createPageTitle('تغییر رمز عبور');
        }

    }
</script>

<style scoped>
    .account-box {
        margin: 100px auto;
    }
</style>